// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/components/UserMenu/UserMenu.css */

.user-menu {
  position: relative;
}

.user-menu__trigger {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  padding: 2px var(--space-sm);
  border-radius: var(--radius-full);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background-color var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
}

.user-menu__trigger:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.user-menu__avatar {
  width: 28px;
  height: 28px;
  border-radius: var(--radius-full);
  background-color: var(--color-wood-light);
  color: var(--color-text-on-wood);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  flex-shrink: 0;
}

.user-menu__name {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-on-wood);
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu__chevron {
  width: 12px;
  height: 12px;
  fill: var(--color-text-on-wood);
  opacity: 0.7;
  transition: transform var(--transition-fast);
}

.user-menu__trigger--open .user-menu__chevron {
  transform: rotate(180deg);
}

/* ---- Dropdown ---- */
.user-menu__dropdown {
  position: absolute;
  top: calc(100% + var(--space-xs));
  right: 0;
  min-width: 200px;
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
  z-index: 150;
  animation: user-menu-fade-in 0.15s ease-out;
  overflow: hidden;
}

@keyframes user-menu-fade-in {
  0% {
    opacity: 0;
    transform: translateY(-4px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-menu__user-info {
  padding: var(--space-sm) var(--space-md);
  border-bottom: 1px solid var(--color-border);
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.user-menu__user-info:hover {
  background-color: var(--color-progress-bg);
}

.user-menu__user-info-hint {
  font-size: 0.6rem;
  color: var(--color-text-light);
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.user-menu__user-name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.user-menu__user-email {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu__item {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  background: transparent;
  border: none;
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: background-color var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  text-decoration: none;
  text-align: left;
}

.user-menu__item:hover {
  background-color: var(--color-progress-bg);
}

.user-menu__item--danger {
  color: var(--color-error);
  border-top: 1px solid var(--color-border);
}

.user-menu__item--danger:hover {
  background-color: rgba(229, 57, 53, 0.06);
}

.user-menu__item-icon {
  font-size: var(--font-size-base);
  line-height: 1;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/UserMenu/UserMenu.css"],"names":[],"mappings":"AAAA,8FAA8F;;AAE9F;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,iCAAiC;EACjC,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mDAAmD;EACnD,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,yCAAyC;EACzC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iCAAiC;EACjC,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;EACxC,4CAA4C;EAC5C,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,mDAAmD;EACnD,wCAAwC;EACxC,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/components/UserMenu/UserMenu.css */\n\n.user-menu {\n  position: relative;\n}\n\n.user-menu__trigger {\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n  padding: 2px var(--space-sm);\n  border-radius: var(--radius-full);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n}\n\n.user-menu__trigger:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.user-menu__avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-full);\n  background-color: var(--color-wood-light);\n  color: var(--color-text-on-wood);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  flex-shrink: 0;\n}\n\n.user-menu__name {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-on-wood);\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-menu__chevron {\n  width: 12px;\n  height: 12px;\n  fill: var(--color-text-on-wood);\n  opacity: 0.7;\n  transition: transform var(--transition-fast);\n}\n\n.user-menu__trigger--open .user-menu__chevron {\n  transform: rotate(180deg);\n}\n\n/* ---- Dropdown ---- */\n.user-menu__dropdown {\n  position: absolute;\n  top: calc(100% + var(--space-xs));\n  right: 0;\n  min-width: 200px;\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--color-border);\n  z-index: 150;\n  animation: user-menu-fade-in 0.15s ease-out;\n  overflow: hidden;\n}\n\n@keyframes user-menu-fade-in {\n  0% {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.user-menu__user-info {\n  padding: var(--space-sm) var(--space-md);\n  border-bottom: 1px solid var(--color-border);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n}\n\n.user-menu__user-info:hover {\n  background-color: var(--color-progress-bg);\n}\n\n.user-menu__user-info-hint {\n  font-size: 0.6rem;\n  color: var(--color-text-light);\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.user-menu__user-name {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.user-menu__user-email {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-menu__item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  background: transparent;\n  border: none;\n  color: var(--color-text-primary);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  text-decoration: none;\n  text-align: left;\n}\n\n.user-menu__item:hover {\n  background-color: var(--color-progress-bg);\n}\n\n.user-menu__item--danger {\n  color: var(--color-error);\n  border-top: 1px solid var(--color-border);\n}\n\n.user-menu__item--danger:hover {\n  background-color: rgba(229, 57, 53, 0.06);\n}\n\n.user-menu__item-icon {\n  font-size: var(--font-size-base);\n  line-height: 1;\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
